const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz'

/**
 * Time-ordered ids: a millisecond prefix in base36 plus randomness. Blocks then
 * sort by id in roughly the same order they sort by start, which keeps Firestore
 * queries and local sorts cheap, and keeps offline-created ids collision-free.
 */
export function newId(now: number = Date.now()): string {
  const time = now.toString(36).padStart(9, '0')
  const bytes = new Uint8Array(8)
  crypto.getRandomValues(bytes)
  let suffix = ''
  for (const byte of bytes) suffix += ALPHABET[byte % ALPHABET.length]
  return `${time}${suffix}`
}
